import { Stack, Typography } from "@mui/material";
import MainNavBar from "../components/MainNavBar";
import AppRightSidebar from "../components/AppRightSidebar";
import ProfileSection from "../components/Profile/ProfileSection";

function Profile() {
  return (
    <Stack>
      <MainNavBar />
      <Stack
        direction="row"
        sx={{ bgcolor: "#f5f6f7", px: "24px", py: "12px" }}
        spacing={2}
      >
        <ProfileSection />
        <AppRightSidebar />
      </Stack>
    </Stack>
  );
}

export default Profile;
